<template>
  <div class="detail">
    <mt-header title="签署文件">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
      <a @click="detail()" slot="right">
        详情
      </a>
    </mt-header>

    <div class="content">
      <div class="pagestyle">{{currentPage}}/{{dataList.length}}</div>
      <div class="unipage">
        <a @click="pagePrev()"><em class="one"></em></a>
         <a class="line-bnone" @click="pageNext()"><em class="four"></em></a>
      </div>
 
      <div class="abscont" v-for="(item,index) in dataList" :key="'page'+index">
        <img v-show="currentPage==index+1" class="signcontract" :src="'/api/'+getSrc(item.src)">
      </div>

    </div>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui';
import cheader from '@/components/header';
export default {
  data () {
    return {
      cid:this.$route.query.cid,
      dataList:'',
      currentPage:'1',
      rooturl:''
    }
  },
  mounted(){
    this.showcontract();
  },
  methods: {
      getSrc:function(src){
        return src+"?sn="+new Date();
      },
      detail:function(){
          this.$router.push({name: 'dcontent', query:{'cid': this.cid}});
      },
      showcontract:function(){
        var that = this;      
        that.$http.post(
            domain("_showcontract"),
            {
              'contractId':this.cid,
              'isDetail':'1',
            }
        )
        .then(function(response){  
            console.log(response);
            that.dataList=response.body.data.imgList;
            that.rooturl = domain("_rooturl")+"/";
            },function(error){
              console.log(error);
        })
      },
      pagePrev:function(){
        if(this.currentPage == 1){
        }else{
          this.currentPage--;
        }
      },
      pageNext:function(){
        if(this.currentPage == this.dataList.length){
        }else{
          this.currentPage++;
        }
      },
      goback: function () {
        history.go(-1); //后退1页
      }
  },
  components:{
     cheader
  }
}
</script>
<style>
.detail .mint-header{
  position: fixed;
  width: 100%;
  z-index: 2;
}
.detail .content{
  padding: 50px 0 60px;
}
.signbottom{
  width:100%;
  height:56px;
  background-color: #f0f0f0;
  border-top: 1px solid #d7d7d7;
  bottom: 0;
  position: fixed;
  z-index: 2;
  display: flex;
}
.signflex{
  padding: 7px 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
}
.signflex img{
  width:20px;
}
.signflex .signimg{
  width:15px;
}
.signflex div{
  color: #1f74d8;
  font-size: 0.8rem;
}
.pagestyle{
  width:42px;
  height:24px;
  line-height:24px;
  background-color: #d2d2d2;
  filter:alpha(opacity=80); /* IE */
  -moz-opacity:0.8; /* 老版Mozilla */
  -khtml-opacity:0.8; /* 老版Safari */
  opacity: 0.8; /* 支持opacity的浏览器*/
  border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
  position: fixed;
  z-index: 2;
  text-align: center;
  color: #ffffff;
  right:5px;
  margin-top: 10px;
}
.unipage{
  width: 30px;
  background: #cccccc;
  right: 0;
  top: 50%;
  margin-top: -54px;
  position: fixed;
  z-index: 2;
  border-radius: 5px 0 0 5px;
  opacity: 0.6;
}
.unipage a{
  width: 100%;
  height: 32px;
  display: inline-block;
  color: #fff;
  text-decoration: none;
  text-align: center;
  background-size: 60% auto;
}
.unipage a em{
  margin-top:10px;  
  text-indent: -9999px;
  display: block;
  background-size: 18px auto;
  font-style: normal;
  font-size: 11px;
  letter-spacing: -1px;
  margin: 0 auto;
}
.unipage a .one{
  margin-top:10px;
  width: 15px;
  height: 15px;
  background: url(/static/img/contract/down.png) no-repeat center;
}
.unipage a .four{
  margin-top:10px;
  width: 15px;
  height: 15px;
  background: url(/static/img/contract/up.png) no-repeat center;
} 
.abscont{
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/module/contract/Detail.vue